export enum ShipmentLineResetType {
  StreamingShipmentLineForLicensing,
  StreamingShipmentLineForPackageAssignment,
  CinelinkShipmentLineForLicensing,
  CvdShipmentLineForBurning,
  CvdShipmentLineForPinPlay,
  CvdShipmentLineForAuthoring,
  CvdShipmentLineForTranscoding,
  LegacyElectronicDeliveryLineForEncryption,
  AdebsDriveShipmentLineForEncryption
}
